import {  CategoryType, JaiminiType, MDADPredictionType, MonthEnum, NadiType, PadithiEnum, PredictionType } from "./enums";

export const PADITHI_OPTIONS = [
  { label: "Lalkitab", value: PadithiEnum.LAL_KITAB },
  { label: "Nadi", value: PadithiEnum.NADI },
  { label: "Parashara", value: PadithiEnum.PARASHARA },
  { label: "Jaimini", value: PadithiEnum.JAIMINI },
];

export const CATEGORY_OPTIONS = [
  { label: "Promise", value: CategoryType.PROMISE },
  { label: "Key", value: CategoryType.KEY },
  { label: "Career", value: CategoryType.CAREER },
  { label: "Relationship", value: CategoryType.RELATIONSHIP },
  { label: "Finance", value: CategoryType.FINANCE },
  { label: "Health", value: CategoryType.HEALTH },
  { label: "Legal", value: CategoryType.LEGAL },
  { label: "Education", value: CategoryType.EDUCATION },
  { label: "Comfort", value: CategoryType.COMFORT },
  { label: "Family", value: CategoryType.FAMILY },
  { label: "Remedy", value: CategoryType.REMEDY },
  { label: "Caution", value: CategoryType.CAUTION },
  { label: "Tag", value: CategoryType.TAG },
];

export const PREDICTION_TYPE_OPTIONS = [
  { label: "Yearly Snapshot", value: PredictionType.YEAR },
  { label: "Monthly Snapshot", value: PredictionType.MONTH },
  { label: "Day", value: PredictionType.DAY },
  { label: "Notification", value: 'NOTIFICATION' },
];

export const NADI_PREDICTION_TYPE_OPTIONS = [
  { label: "Nadi", value: NadiType.NADI },
  { label: "Nadi Degree", value: NadiType.NADI_DEGREE },
]

export const JAIMINI_PREDICTION_TYPE_OPTIONS = [
  { label: "Mahadasha", value: JaiminiType.MAHADASHA },
  { label: "Antradasha", value: JaiminiType.ANTRADASHA },
]

export const MONTH_OPTIONS = Object.entries(MonthEnum)
  .filter(([key]) => key !== "CURRENT_MONTH")
  .map(([key, value]) => ({
    label: key.charAt(0) + key.slice(1).toLowerCase(),
    value,
  }));

export const MD_AD_PREDICTION_TYPE_OPTIONS = [
  { label: "MD", value: MDADPredictionType.MD },
  { label: "AD", value: MDADPredictionType.AD },
]